<template>
  <v-container
    ><div style="text-align: center; padding-left: 30% !important" width="100%">
      <v-alert
        v-if="responseStatus.alertStatus"
        :type="responseStatus.type"
        width="40%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
      >
        {{ responseStatus.text }}
      </v-alert>
    </div>
    <v-card>
      <v-card-title>Redeem Information</v-card-title>
      <v-card-text
        ><v-container>
          <v-row>
            <v-col sm="12" md="12" xs="12" lg="12"
              ><v-text-field
                readonly="readonly"
                v-model="redeemInfo.status"
                label="Status"
              ></v-text-field></v-col></v-row
          ><v-row>
            <v-col sm="12" md="12" xs="12" lg="12"><v-img :src="image"></v-img></v-col
          ></v-row>
          <v-row>
            <v-col sm="12" md="12" xs="12" lg="12"
              ><v-text-field
                readonly="readonly"
                v-model="redeemInfo.privilegeId.name"
                label="ของรางวัล"
              ></v-text-field></v-col
          ></v-row>
          <v-row>
            <v-col sm="12" md="12" xs="12" lg="12"
              ><v-text-field
                readonly="readonly"
                v-model="redeemInfo.privilegeId.value"
                label="มูลค่า"
              ></v-text-field></v-col
          ></v-row>
          <!-- <v-row>
          <v-col sm="12" md="12" xs="12" lg="12"
            ><v-text-field
              readonly="readonly"
              v-model="redeemInfo.privilegeId.point"
              label="คะแนน"
            ></v-text-field></v-col
        ></v-row> -->
          <v-row>
            <v-col sm="12" md="12" xs="12" lg="12"
              ><v-text-field
                readonly="readonly"
                v-model="memberName"
                label="สมาชิก"
              ></v-text-field></v-col></v-row
        ></v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="primary"
          @click="update('Approved')"
          :disabled="redeemInfo.status != 'Pending'"
          >อนุมัต</v-btn
        >
        <v-btn
          class="warning"
          @click="update('Rejected')"
          :disabled="redeemInfo.status != 'Pending'"
          >ปฏิเสธ</v-btn
        >
        <v-btn class="secondary" @click="close()">ปิด</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  props: {
    redeemInfo: {
      type: Object,
    },
  },
  name: "RedeemInfo",
  data() {
    return {
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      responseStatus: {
        alertStatus: false,
      },
      image:
        process.env.VUE_APP_LOYALTY_API_URI +
          "/public/" +
          this.redeemInfo.privilegeId.image || "",
    };
  },
  computed: {
    memberName() {
      return this.redeemInfo.memberId.firstname + " " + this.redeemInfo.memberId.lastname;
    },
  },
  methods: {
    update(status) {
      console.log(status);
      let payload = {
        status: status,
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        apiKey: sessionStorage.getItem("apiKey"),
      };
      this.$emit("updateRedeem", payload);
      //let response = await this.$store.dispatch("updatePendingRedeem", payload);
      //console.log(response);
    },
    close() {
      this.$emit("close");
    },
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },
  },
  mounted() {
    // console.log(this.redeemInfo);
    // console.log(this);
  },
  watch: {
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
